import React, { Component } from 'react';
import $ from 'jquery';
import config from "../config";
import { gapi } from 'gapi-script';
import axios from 'axios';
import moment from 'moment';
import { ulid } from 'ulid'
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Button, TextField, Table, TableSortLabel, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';

import {DebounceInput} from 'react-debounce-input';

export default class MongoSuggestFields extends Component {
	
	constructor(props){
        super(props)
		this.state ={
			filterForms:[],
			suggestedFields:[],
			selectedForm:'',
			selectedStatus:'',
			page:0,
			rowsPerPage:10,
		}
    }
	
	componentDidMount() {
		this.getSuggestedFields();
	}
	
	getValue=(event)=>{
		let name = event.target.name;
		let res = event.target.value;
		this.setState({[event.target.name]:event.target.value});
		
		let that = this;
		if(name == 'selectedForm' || name == 'selectedStatus'){
			setTimeout(function(){
				that.filterMdsForms();
			}, 1000);
		}
	}
	
	getSuggestedFields=()=>{
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'field-suggestions';
		axios({
			method: 'GET',
			url: url,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			let suggestedFields = response.data;
			let frm = [];
			suggestedFields.map((sheet,i)=>{
				frm.push(sheet.MDSName);
			});
			let mdsforms = this.uniqueArray2(frm);
			this.setState({suggestedFields,filterForms:suggestedFields,mdsforms});
		}).catch(error => {
			console.log('error::', error);
		})
	}
	
	filterMdsForms=()=>{
		let suggestedFields = this.state.suggestedFields;
		let selectedForm = this.state.selectedForm;
		let selectedStatus = this.state.selectedStatus;
		let mdsForms = [];
		suggestedFields.map((field,i)=>{
			if(this.state.selectedForm && this.state.selectedForm != field.MDSName){
				return false;
			}
			
			if(this.state.selectedStatus && this.state.selectedStatus != field.Status){
				return false;
			}
			
			mdsForms.push(field);
		});
		
		this.setState({filterForms:mdsForms});
	}
	
	uniqueArray2(arr) {
		var a = [];
		for (var i=0, l=arr.length; i<l; i++)
			if (a.indexOf(arr[i]) === -1 && arr[i] !== '')
				a.push(arr[i]);
		return a;
	}
	
	handleChangePage = (event: unknown, newPage: number) => {
		this.setState({page:newPage});
		let that = this;
		setTimeout(function(){
			that.checkMdsFields();
		}, 1000);
		
	};

	handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({rowsPerPage:event.target.value,page:0});
	};
	
	handleSort = column => {
		const { sortBy, sortOrder } = this.state;
		const isAsc = sortBy === column && sortOrder === 'asc';
		this.setState({
		  sortBy: column,
		  sortOrder: isAsc ? 'desc' : 'asc'
		});
	};
	
	updateStatus=(event)=>{
		let name = event.target.name;
		let value = event.target.value;
		let uid = event.target.id;

		let dynamicKey = '';
		
		if(name == 'internalReview'){
			dynamicKey = 'InternalReview';
		}else if(name == 'status'){
			dynamicKey = 'Status';
		}else if(name == 'suggestNote'){
			dynamicKey = 'Note';
		}
		
		let mongoApiUrl = config.mongoApiUrl;
		let url = mongoApiUrl+'update-suggest';
		
		let data = {
			"UID": uid,
			[dynamicKey]:value,
		}
		
		axios({
			method: 'POST',
			url: url,
			data: data,
			headers: {
				'Content-Type': 'application/json',
			}
		})
		.then(response => {
			this.getSuggestedFields();
		}).catch(error => {
			console.log('error::', error);
		})

	}
	

	render() {
		const {suggestedFields,filterForms,selectedForm,selectedStatus,sortBy,sortOrder,mdsforms} = this.state;
		
		const StyledTableCell = styled(TableCell)(({ theme }) => ({
		  [`&.${tableCellClasses.head}`]: {
			//backgroundColor: '#e9e9e9',
			color: '#000;',
			padding: '15px 5px;',
			fontWeight: 600,
			fontSize: 15,
		  },
		  [`&.${tableCellClasses.body}`]: {
			fontSize: 15,
			backgroundColor: '#ffffff',
		  },
		}));
		
		const sortedData = [...filterForms].sort((a, b) => {
		  const isAsc = sortOrder === 'asc';
		  if (a[sortBy] < b[sortBy]) {
			return isAsc ? -1 : 1;
		  }
		  if (a[sortBy] > b[sortBy]) {
			return isAsc ? 1 : -1;
		  }
		  return 0;
		});
		
		let optionHtml = '';
		if(mdsforms){
			optionHtml = mdsforms.map(function(val,i) {
				return (
					<MenuItem value={val} key={i}>{val}</MenuItem>
				);
			})
		} 

		return (
			<div className="user-manager-mongo custom-container suggest-list">
				
				<div className="mongo-header">
					<div className="mg-user-title"><h5>Suggested Field Manager</h5></div>
					<div className="wp-mode-filter">
						<FormControl sx={{ m: 1, minWidth: 235, maxWidth: 235 }} size="small">
							<InputLabel>Select Status</InputLabel>
							<Select
								value={selectedStatus}
								name={'selectedStatus'}
								onChange={this.getValue}
								input={<OutlinedInput label="Select Status" />}
							>
							<MenuItem value={''} >Select Status</MenuItem>
							<MenuItem value={'Active'} >Active</MenuItem>
							<MenuItem value={'Inactive'} >Inactive</MenuItem>
							<MenuItem value={'Completed'} >Completed</MenuItem>
							
							</Select>
						</FormControl>
					</div>
					<div className="wp-mode-filter">
						<FormControl sx={{ m: 1, minWidth: 235, maxWidth: 235 }} size="small">
							<InputLabel>Select Form</InputLabel>
							<Select
								value={selectedForm}
								name={'selectedForm'}
								onChange={this.getValue}
								input={<OutlinedInput label="Select Form" />}
							>
							<MenuItem value={''} >Select Form</MenuItem>
							{optionHtml}
							</Select>
						</FormControl>
					</div>
					
				</div>
				
				{suggestedFields ?
				<div className="mg-child-sheets">
				<TableContainer>
				  <Table size="small" aria-label="a dense table">
					<TableHead>
					  <TableRow key={11}>
							<StyledTableCell>Name of Form</StyledTableCell>
							<StyledTableCell>Username</StyledTableCell>
							<StyledTableCell>Date</StyledTableCell>
							<StyledTableCell>Goal</StyledTableCell>
							<StyledTableCell>Suggested Field Type</StyledTableCell>
							<StyledTableCell>Visible Text</StyledTableCell>
							<StyledTableCell>Options</StyledTableCell>
							<StyledTableCell>Additional  Informaton</StyledTableCell>
							<StyledTableCell width={'155px'}>Internal Review</StyledTableCell>
							<StyledTableCell width={'130px'}>Status</StyledTableCell>
							<StyledTableCell width={'165px'}>Notes</StyledTableCell>

					  </TableRow>
					</TableHead>
					<TableBody>
					  {sortedData.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((val) => {
						  
						//let status = this
						
						return (<TableRow key={val.UID} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
						  <StyledTableCell>{val.MDSName} </StyledTableCell>
								<StyledTableCell>{val.UserName} </StyledTableCell>
								<StyledTableCell>{val.Date} </StyledTableCell>
								<StyledTableCell>{val.Goal} </StyledTableCell>
								<StyledTableCell>{val.FieldType} </StyledTableCell>
								<StyledTableCell>{val.VisibleText} </StyledTableCell>
								<StyledTableCell>{val.Options}</StyledTableCell>
								<StyledTableCell>{val.AdditionalInformaton} </StyledTableCell>
								<StyledTableCell>
								<select id={val.UID} className="form-control" name='internalReview' value={val.InternalReview} onChange={this.updateStatus}>
									<option value="New">New</option>
									<option value="Yes Will Add">Yes Will Add</option>
									<option value="No Wont Add">No Won't Add</option>
									<option value="Added">Added</option>
									<option value="Customer Approved">Customer Approved</option>
								</select>
								</StyledTableCell>
								<StyledTableCell>
								<select id={val.UID} className="form-control" name='status' value={val.Status} onChange={this.updateStatus}>
									<option value="Active">Active</option>
									<option value="Inactive">Inactive</option>
									<option value="Completed">Completed</option>
								</select>
								</StyledTableCell>
								<StyledTableCell><DebounceInput id={val.UID} debounceTimeout={6000} element="textarea" rows="1" value={val.Note} className="form-control" name="suggestNote" onChange={this.updateStatus}/></StyledTableCell>
						  
						</TableRow>)
					  })}
					</TableBody>
				  </Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[5, 10, 20, 50, 100]}
					component="div"
					count={suggestedFields.length}
					rowsPerPage={this.state.rowsPerPage}
					page={this.state.page}
					onPageChange={this.handleChangePage}
					onRowsPerPageChange={this.handleChangeRowsPerPage}
				/>
				</div>
				:null}
				
			</div>
		);	
	}	
}
